export default __webpack_public_path__ + "static/media/walletconnection.58bf9a39.png";